import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCopyToClipboard } from 'react-use';
import styled from 'styled-components';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { Button } from 'ui/button';
import { MakeCopy } from 'ui/icons';
import { spacing } from 'ui/theme';

type Props = {
  text: string;
};

const SpacedButton = styled(Button)`
  margin-bottom: ${spacing.base};
`;

export const CopyToClipboardButton = ({ text }: Props) => {
  const dispatch = useDispatch();
  const [{ value, error }, copyToClipboard] = useCopyToClipboard();

  useEffect(() => {
    if (value) dispatch(addPositiveToast('Successfully copied content to clipboard.'));
  }, [value]);

  useEffect(() => {
    if (error) dispatch(addNegativeToast('Failed to copy content to clipboard.'));
  }, [error]);

  return (
    <SpacedButton
      onClick={() => {
        copyToClipboard(text);
      }}
    >
      <MakeCopy />
      <span>Copy to clipboard</span>
    </SpacedButton>
  );
};
